import { z } from 'zod';
import { strikeSchema } from './strike.schema';
export const underlyingsSchema = z.array(strikeSchema).superRefine((lines, ctx) => {
    const hasMissingValues = lines.some((line) => {
        const values = [line.underlying_id, line.percent, line.value];
        return values.some((value) => value === undefined || value === null || isNaN(value));
    });
    if (hasMissingValues) {
        ctx.addIssue({
            code: 'custom',
            message: 'All information must be filled',
            path: ['underlyings'],
        });
    }
});
